import {
  navigate,
  sendGetRequest,
  formatDate,
  sendDeleteRequest,
  getNotificationStatus,
  watchLiveData,
  toTzTimeFormat,
  allowedOperations,
} from "../utils/utils";
import DataList from "./component/@list/list";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";
import { useSelector } from "react-redux";
import DataListWithSearch from "./component/@list/list-search";

const getTableHead = () => {
  return [
    { id: "createAt", label: "Added on", alignRight: false },
    { id: "type", label: "Category", alignRight: false },
    { id: "heading", label: "Heading", alignRight: false },
    { id: "title", label: "Title", alignRight: false },
    { id: "message", label: "Message", alignRight: false },
    { id: "imageUrl", label: "Image", alignRight: false },
    { id: "scheduledAt", label: "Scheduled At", alignRight: false },
    { id: "_", alignRight: false },
  ];
};

const NotificationsList = () => {
  const [dataList, setDataList] = useState([]);
  const [loading, onLoading] = useState(false);
  const { queue } = useSelector((state) => state.queue);
  const { canEdit, canDelete, canCreate } = allowedOperations();

  const actionOptions = [
    canDelete ? {
      icon: "delete",
      value: "delete",
      label: "Delete",
      onClick: (value, selected) => {
        onLoading(true);
        Promise.all(
          selected.map((uuid) => sendDeleteRequest("notifications", uuid))
        ).then((_) => executeFetch());
      },
    }: null,
    canEdit ? {
      icon: "edit_note",
      value: "edit",
      label: "Edit",
      onClick: (_value, selected) =>
        navigate(
          `${AppRoutes.notifications}/${
            AppRoutes.notification
          }?uuid=${selected.join("")}`,
          true
        ),
    }: null,
  ].filter(Boolean);
  const filterOptions = [];

  const executeFetch = (refresh = false) => {
    sendGetRequest(
      "notifications",
      (loading) => onLoading(loading),
      (data) => setDataList(data)
    );
  };

  useEffect(() => {
    executeFetch();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (queue) watchLiveData(queue, "notifications", (_) => executeFetch(true));
    // eslint-disable-next-line
  }, [queue]);

  return (
    <div>
      <DataListWithSearch
        sectionTitle="Notifications"
        createNewLabel={ canCreate ? "Add Notification": null}
        data={dataList}
        primaryKey="uuid"
        filterColumn="title"
        emptyIcon="notification_add"
        avatarKey="_"
        loading={loading}
        onBack={() => navigate(`${AppRoutes.contents}`, true)}
        onCreateNewItem={() =>
          navigate(`${AppRoutes.notifications}/${AppRoutes.notification}`, true)
        }
        headers={getTableHead()}
        rowData={(data) => {
          const _entries = [
            {
              value: toTzTimeFormat(data.createdAt, "MMM DD, YYYY, hh:mmA"),
              width: 200,
            },
            { value: data.type === "push" ? "Push" : "Pop Up", width: 60 },
            { value: data.heading, width: 200 },
            { value: data.title },
            { value: data.message, width: 200 },
            { value: data.imageUrl ? "With Image" : "No Image", width: 100 },
            {
              value: data.scheduledAt
                ? formatDate(data.scheduledAt, "MMM DD, YYYY, hh:mmA")
                : "Not Scheduled",
            },
            { ...getNotificationStatus(data.executed || false) },
          ];
          return {
            exclude: [data.executed ? "edit" : ""],
            entries: _entries,
          };
        }}
        selectionOptions={actionOptions.filter((option) => option.value === "delete")}
        filterOptions={filterOptions}
        optionItems={actionOptions}
      />
    </div>
  );
};

export default NotificationsList;
